import { render } from "./3DataPPID.vue?vue&type=template&id=8df3f5f2"
import script from "./3DataPPID.vue?vue&type=script&lang=js"
export * from "./3DataPPID.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__